<template>
  <div class="c-home c-page">
    <div class="c-page__inner l-columns-container l-columns-container--outmost">
      <div class="l-tablet-column--6">
        <h1 class="f-headline">
          <strong>Din</strong> indbakke
        </h1>
        <div class="l-columns-container">
          <div class="l-laptop-column--8">
            <div>
              <p
                class="f-text"
              >Her kan du se de seneste nyhedsbreve fra hele vores univers. Også dem, du ikke normalt modtager på email.</p>
              <p class="f-text">
                <router-link
                  :to="{name: 'product-settings'}"
                >Justér dine abonnementsindstillinger her.</router-link>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="l-tablet-column--6">
        <ul class="c-home__campaigns">
          <li
            v-for="(newsletter, j) in paginatedCampaigns"
            :key="'newsletter_' + newsletter.list.listid + '_' + j"
            class="c-home__campaign"
          >
            <a
              :href="newsletter.campaign.archive_url"
              class="f-link--reset c-home__campaign__image-container"
            >
              <img :src="newsletter.list.listthumbnail" class="c-home__campaign__image" />
            </a>
            <a
              :href="newsletter.campaign.archive_url"
              class="f-link--reset c-home__campaign__content"
            >
              <h2 class="c-home__campaign__subject">{{ newsletter.campaign.settings.subject_line }}</h2>
              <p class="f-small">
                <span class="c-home__campaign__sender f-italic">{{ newsletter.list.listtitle }}</span> den
                <span>{{ formattedDate(newsletter.campaign.send_time) }}</span>
              </p>
            </a>
          </li>
        </ul>

        <div class="c-pagination">
          <button
            id="prev"
            :class="{ disabled: prevDisabled}"
            class="c-pagination__button c-pagination__button--prev"
            @click="prevPage()"
          >
            <ArrowLink title="Nyere" arrow-right="true" class="c-link--arrow--left" />
          </button>

          <button
            id="next"
            :class="{ disabled: nextDisabled}"
            class="c-pagination__button c-pagination__button--next"
            @click="nextPage()"
          >
            <ArrowLink title="Ældre" class="c-link--arrow--right" label-left />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
const axios = require("axios");
const newslettersPerPage = 5;
import ArrowLink from "@/components/ArrowLink.vue";

export default {
  name: "Home",
  components: {
    ArrowLink
  },
  data() {
    return {
      user: this.$route.meta.user,
      campaigns: null,
      paginatedCampaigns: null,
      page: 0,
      months: [
        "januar",
        "februar",
        "marts",
        "april",
        "maj",
        "juni",
        "juli",
        "august",
        "september",
        "oktober",
        "november",
        "december"
      ],
      prevDisabled: true,
      nextDisabled: true
    };
  },
  created() {
    axios.defaults.headers.common = {
      Authorization: `bearer ${this.user.token}`
    };
  },
  mounted() {
    console.log(this.$router);
    if (!this.user) {
      // redirect
      this.$router.push({ name: "login" });
      return;
    }
    return axios
      .get(process.env.VUE_APP_PUMAS_API_URL + "central/frontpage-campaigns")
      .then(response => {
        this.campaigns = response.data;
        this.noPages = Math.floor(this.campaigns.length / newslettersPerPage);
        this.updateUI();
      })
      .catch(error => {
        throw new Error(error);
      });
  },
  methods: {
    nextPage() {
      console.log("next");
      if (this.noPages > this.page) {
        this.page++;
        this.updateUI();
      }
    },
    prevPage() {
      console.log("prev");
      if (this.page > 0) {
        this.page--;
        this.updateUI();
      }
    },
    updateUI() {
      this.paginatedCampaigns = this.campaigns.slice(
        this.page * newslettersPerPage,
        (this.page + 1) * newslettersPerPage
      );
      this.prevDisabled = this.page === 0;
      this.nextDisabled = this.page >= this.noPages;
    },
    formattedDate(date_time) {
      const date = new Date(date_time);
      const day = date.getDate();
      const month_index = date.getMonth();
      const month = this.months[month_index];
      const year = date.getFullYear();
      const formatted_date_time = day + ". " + month + " " + year;

      return formatted_date_time;
    }
  }
};
</script>

<style lang="scss">
@import "../vars";
@import "../_mixins";
@import "../pagination";

$thumbnailSize: 3.5em;

.c-home {
  justify-content: space-between;

  &__campaigns {
    @include bp("max-width" #{$tablet - 1}) {
      margin-top: 2rem;
    }
  }

  &__campaign {
    display: flex;
    align-items: center;
    margin-bottom: 1.5em;

    &__image-container {
      position: relative;
      flex: 1 1 $thumbnailSize;
      height: 0;
      margin-right: 1em;
      padding-bottom: $thumbnailSize;
      border-radius: 100%;
      overflow: hidden;
    }

    &__image {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      height: 100%;
      object-fit: cover;
    }

    &__content {
      flex: 1 1 calc(100% - #{$thumbnailSize});
    }

    &__sender {
      font-family: $ffSubHead;
      font-family: $ffHead;
      font-weight: bold;
    }
  }
}
</style>
